import { Offcanvas } from "bootstrap";
import offcanvasController from "./controller.js";

export default offcanvasController(Offcanvas);
